import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import AddressSelect from './CheckoutSearchSelect';
import { toast } from 'react-toastify';
import axios from '@/lib/axios';
import { useRouter } from 'next/navigation';

const CheckoutForm = ({ address, product }: any) => {
  const router = useRouter();
  const addressData = address?.data?.[0] || {};
  const shippingCharge = product?.group_shipping_charge;
  const total = product.group_purchase_price + shippingCharge;
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, setValue, watch } = useForm({
    defaultValues: {
      product_id: product.id,
      shipping_name: addressData.name || '',
      shipping_phone: addressData.phone || '',
      shipping_address: addressData.address || '',
      shipping_city_id: addressData.city_id || null,
      shipping_zone_id: addressData.zone_id || null,
      shipping_area_id: addressData.area_id || null,
      payment_method: 'bkash',
      note: '',
    },
  });

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      const res = await axios.post(`/api/v2/groups/store`, data);

      if (res.data.result) {
        router.push(res.data.data.payment_url);
      } else {
        toast.error(res.data.message[0] || 'Creating group failed');
      }
    } catch (error) {
      toast.error('Creating group failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-12">
      <form onSubmit={handleSubmit(onSubmit)} className="checkout__details">
        <div className="row g-3 gy-0 ">
          <div className="col-lg-12">
            <div className="checkout__subtitle">
              <p className="mt-0">Billing Details</p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-group">
              <input
                {...register('shipping_name')}
                className="form-control"
                placeholder="Name*"
                required
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-group">
              <input
                {...register('shipping_phone')}
                className="form-control"
                placeholder="Phone*"
                required
              />
            </div>
          </div>
          <AddressSelect setValue={setValue} watch={watch} />
          <div className="col-12">
            <div className="input-group">
              <input
                {...register('shipping_address')}
                className="form-control"
                placeholder="Address"
                required
              />
            </div>
          </div>
          <div className="col-12">
            <div className="input-group">
              <textarea
                {...register('note')}
                className="form-control"
                rows={4}
                placeholder="Write a message..."
              />
            </div>
          </div>

          <div className="col-12 mt-3">
            <div className="checkout__subtitle">
              <p>Select Payment Method</p>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                value="bkash"
                {...register('payment_method')}
                id="bkash"
                defaultChecked
              />
              <label className="form-check-label" htmlFor="bkash">
                Bkash
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                value="ssl"
                {...register('payment_method')}
                id="ssl"
              />
              <label className="form-check-label" htmlFor="ssl">
                Online payment SSL
              </label>
            </div>
          </div>
          <div className="col-12">
            <div className="checkout__summary border p-3 rounded mb-3">
              <div className="d-flex justify-content-between">
                <span>Sub total</span>
                <span>৳{product.group_purchase_price}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Shipping charge</span>
                <span>৳{shippingCharge}</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between fw-bold">
                <span>Total</span>
                <span>৳{total}</span>
              </div>
            </div>
          </div>

          <div className="col-12">
            <button
              type="submit"
              className="trk-btn trk-btn--primary w-100 mt-3"
              disabled={loading}
            >
              {loading ? 'Placing Order...' : 'Place Order'}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CheckoutForm;
